export function generateDarkerHexColor(hex: string, percentage = 10): string {
  // Ensure the hex color is valid and 7 characters long
  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return hex; // Return the original color if invalid
  }

  const rgb = hexToRgb(hex);

  // Darken each channel
  const darkenedRGB = Object.entries(rgb).reduce<{ [key: string]: number }>(
    (acc, [key, value]) => {
      acc[key] = Math.max(0, value - Math.round((percentage / 100) * 255));
      return acc;
    },
    {}
  );

  // Convert back to hex
  const darkenedHex = `#${Object.values(darkenedRGB)
    .map((val) => val.toString(16).padStart(2, '0'))
    .join('')}`;

  return darkenedHex;
}

function hexToRgb(hex: string): { [key: string]: number } {
  return {
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16),
  };
}
